<script lang="ts" setup>
import Side from '../components/Side.vue'
import Author from '../components/Author.vue'
import Ad from '../components/Ad.vue'
import List from './components/List.vue'
import Content from './components/Content.vue'
import Newsletter from '../components/Newsletter.vue'
import { useArticleStore } from '@/stores'
import type { IHomeHenceCard } from '@/utils/types'
import useSeo from './seo'

const route = useRoute()
const articleId = route.params.id as string
const { advert } = useApi()
const articleStore = useArticleStore()
await articleStore.fetchArticleCategories('projectCategories', {
  className: 'articleProject'
})
await articleStore.fetchArticle(articleId)
const article = computed(() => articleStore.hence)
const recommends = computed(() =>
  articleStore.recommends.map((item) => {
    return {
      image: item.image,
      category: item.categories.length > 0 ? item.categories[0].subject : '',
      title: item.subject,
      link: `/hence/article/${item.id}`
    } as IHomeHenceCard
  })
)

onMounted(() => {
  nextTick(() => {
    articleStore.fetchArticleRecommends(articleId)
  })
})

const { data: advertData } = await advert.getAdvert('hence-detail')
const advertRes = computed(() => advertData.value?.data)

useSeo(article.value)
</script>

<template>
  <section class="hence">
    <div class="hence__sideBox">
      <Side class="hence__side" :category-name="article.categories.length > 0 ? article.categories[0].subject : ''"
        :date="article.publish_date" />
    </div>
    <section class="hence__content">
      <Content :data="article" />
    </section>
    <Author :data="article.author" class="hence__author" v-if="article.author" />
    <Ad class="hence__ad" :data="advertRes" v-if="advertRes" />
    <List :items="recommends" class="hence__list" />
    <Newsletter class="hence__full" />
  </section>
</template>

<style lang="scss" scoped>
.hence {
  @include grid;

  @include max-media(1180) {
    @include grid(4, 24);
  }

  @include max-media(767) {
    position: relative;
    z-index: 2;
    transform: translateY(toRem(100));
    margin-top: toRem(-100);
  }

  &__pageLink {
    grid-column: 1 / span 4;

    @include min-media(1181) {
      display: none;
    }
  }

  &__sideBox {
    display: flex;
    justify-content: flex-end;
    grid-column: 1 / span 2;

    @include max-media(1180) {
      display: none;
    }
  }

  &__side {
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    max-height: 90vh;
    overflow-y: auto;
  }

  &__content {
    grid-column: 4 / span 8;
    margin-bottom: toRem(200);

    @include max-media(1180) {
      grid-column: 1 / span 4;
    }

    @include max-media(767) {
      margin-bottom: toRem(50);
    }
  }

  &__author {
    grid-column: 1 / span 12;
    margin-bottom: toRem(180);

    @include max-media(1180) {
      grid-column: 1 / span 4;
    }

    @include max-media(767) {
      margin-bottom: toRem(50);
    }
  }

  &__ad {
    grid-column: 1 / span 12;

    @include max-media(1180) {
      grid-column: 1 / span 4;
    }
  }

  &__list {
    grid-column: 1 / span 12;

    @include max-media(1180) {
      grid-column: 1 / span 4;
    }
  }

  &__full {
    position: relative;
    z-index: 2;
    margin-left: toRem(-24);
    margin-right: toRem(-24);
    grid-column: 1 / span 12;

    @include max-media(1180) {
      grid-column: 1 / span 4;
    }
  }
}
</style>
